//React
import React from 'react'
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as myKeywordAction from '../action/myKeywordAction';
//Add
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';
//Material-ui
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';

//Icon
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

//Part
import PartPageTitle from './PartPageTitle';

//Dialog
import DialogConfirm from './DialogConfirm';

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sampleList: [],
      keywordAddFreeText: '',
      keywordAddFreeTextErr: null,
      keywordAddFreeTextValid: false,
      keywordAddSampleText: null,
      keywordDelId: null,
  	}
  }

  componentDidMount() {
    document.title = 'キーワード - パートナーズ';
    window.scrollTo(0, 0);
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    return axios.post(config.apiUri + "member/keywordSampleListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      if (res.data.bool) {
        this.setState({sampleList: res.data.sample});
      }
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  };

  _keywordAddFreeTextEdit(value) {
    this.setState({ keywordAddFreeText: value});

    if (value.length > 0) {
      if (value.length > 20) {
        this.setState({
          keywordAddFreeTextErr: '20文字以内で記入してください',
          keywordAddFreeTextValid: false,
        });
      }
      else {
        this.setState({
          keywordAddFreeTextErr: '',
          keywordAddFreeTextValid: true,
        });
      }
    }
    else {
      this.setState({
        keywordAddFreeTextValid: false,
      });
    }
  }

  _keywordAddSubmit(keyword) {
    this.props.mykeywordAdd(keyword, () => {
      this.setState({ keywordAddFreeText: ''});
    });
  }

  _keywordDelSubmit() {
    this.props.mykeywordDel(this.state.keywordDelId);
  }

  render() {
    let sampleList = [];


    this.state.sampleList.forEach(sample => {
      let double = this.props.my.keyword.find((v) => v.text === sample);
      if (!double) {
        sampleList.push(sample);
      }
    });
    return (
      <div>
        <PartPageTitle
          title={'キーワードの編集'}
          onback={ '/my/' }
        />

        <div style={{maxWidth:'400px', margin:'auto'}}>

          { ((this.props.config.profileKeywordLimit - this.props.my.keyword.length) > 0) && (
            <div style={{padding:'10px'}}>
              <div align='left'>
                1〜20文字
              </div>
              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  textAlign:'center',
                  alignItems:'center',
                  justifyContent:'space-between',
                }}
              >
                <input
                  style={{fontSize:'1.2em'}}
                  className="input_blue round12"
                  value={this.state.keywordAddFreeText}
                  placeholder="キーワードを入力"
                  maxLength={20}
                  onChange={(e) => this._keywordAddFreeTextEdit(e.target.value)}
                />

                <div style={{width:'100px'}}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={ () => this._keywordAddSubmit(this.state.keywordAddFreeText) }
                    disabled={ (this.state.keywordAddFreeTextValid === true) ? false: true }
                  >
                    <span style={{fontSize:'1.2em'}}>登録</span>
                  </Button>
                </div>
              </div>

              <div style={{color:'red'}}>
                {this.state.keywordAddFreeTextErr}
              </div>
            </div>
          ) }



        </div>

        <div style={{margin:'20px'}}>

          <div align='center' style={{fontSize:'1.2em'}}>
            {this.props.my.keyword.length } / {this.props.config.profileKeywordLimit}
          </div>

          <div align='center'>
          {
            this.props.my.keyword.map(
              (value, index, arr) => {
                return (
                  <Chip
                    key={index}
                    label={ value.text }
                    onDelete={ () => this.setState({keywordDelId: value.id }) }
                    deleteIcon={<DeleteIcon />}
                    variant="outlined"
                    style={{margin:'5px'}}
                  />
                )
              }
            )
          }
          </div>
        </div>

        <div align='center' style={{margin:'20px'}}>
          <h2 align='center'>人気ワード</h2>
          {
            sampleList.map( (value, index, arr) => {
                return (
                  <Chip
                    key={index}
                    icon={<AddIcon />}
                    label={ value }
                    onClick={ () => this.setState({keywordAddSampleText: value}) }
                    variant="outlined"
                    style={{margin:'5px'}}
                  />

                )
            })
          }
        </div>

        <DialogConfirm
          open={ (this.state.keywordAddSampleText) ? true : false }
          title={'キーワードの追加'}
          content={ '"' + this.state.keywordAddSampleText + '" を追加してもいいですか？'}
          apply={ () => {
            this._keywordAddSubmit(this.state.keywordAddSampleText);
            this.setState({keywordAddSampleText: null});
          }}
          close={ () => this.setState({keywordAddSampleText: null}) }
        />
        <DialogConfirm
          open={ (this.state.keywordDelId) ? true : false }
          title={'キーワードの削除'}
          content={　'キーワードを1件削除してもいいですか？'}
          apply={ () => {
            this._keywordDelSubmit();
            this.setState({keywordDelId: null});
          }}
          close={ () => this.setState({keywordDelId: null}) }
        />
      </div>

    )

  }
}


const mapStateToProps = (state) => {
	return {
    config: state.config,
		ui: state.ui,
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...myKeywordAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
